import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** One bucket of the registrations chart, split by gender (U15 — data, never a branch). */
export const MemberRegistrationPointSchema = z
  .object({
    bucket: z.string(),
    male: z.number().int().nonnegative(),
    female: z.number().int().nonnegative(),
  })
  .strict();

export type MemberRegistrationPoint = z.infer<typeof MemberRegistrationPointSchema>;

/** Members by lifecycle status (`users.status`), staff accounts excluded (P27c1). */
export const MemberStatusBreakdownSchema = z
  .object({
    registered: z.number().int().nonnegative(),
    profileIncomplete: z.number().int().nonnegative(),
    pendingVerification: z.number().int().nonnegative(),
    approved: z.number().int().nonnegative(),
    rejected: z.number().int().nonnegative(),
    suspended: z.number().int().nonnegative(),
    banned: z.number().int().nonnegative(),
  })
  .strict();

export type MemberStatusBreakdown = z.infer<typeof MemberStatusBreakdownSchema>;

/**
 * The Dashboard's Members section (D12). Every count excludes staff accounts —
 * "members" here means exactly what the Members list means (`not
 * holdsStaffRole`), never the whole `users` table.
 */
export const MemberStatsSchema = z
  .object({
    window: StatsWindowSchema,
    total: z.number().int().nonnegative(),
    registered: ComparableCountSchema,
    approved: z.number().int().nonnegative(),
    activeLast7d: z.number().int().nonnegative(),
    activeLast30d: z.number().int().nonnegative(),
    hidden: z.number().int().nonnegative(),
    byStatus: MemberStatusBreakdownSchema,
    approvedByGender: z
      .object({ male: z.number().int().nonnegative(), female: z.number().int().nonnegative() })
      .strict(),
    registrationsPerBucket: z.array(MemberRegistrationPointSchema),
  })
  .strict();

export type MemberStats = z.infer<typeof MemberStatsSchema>;
